import FilterAltIcon from '@mui/icons-material/FilterAlt';
import { IconButton } from '@mui/material';
import React from 'react';

import { getDockPillSx } from './dockPillStyles';

export interface FilterDockButtonProps {
  onClick?: () => void;
  'aria-label'?: string;
  sx?: object;
}

const FilterDockButton: React.FC<FilterDockButtonProps> = ({
  onClick,
  'aria-label': ariaLabel = 'Abrir filtros',
  sx,
}) => {
  return (
    <IconButton
      onClick={onClick}
      aria-label={ariaLabel}
      size="medium"
      sx={{
        ...getDockPillSx(),
        width: 44,
        height: 44,
        color: 'primary.main',
        '&.Mui-disabled': {
          color: 'action.disabled',
        },
        ...sx,
      }}
    >
      <FilterAltIcon sx={{ fontSize: 22 }} />
    </IconButton>
  );
};

export default FilterDockButton;
